



















































































































import { defineComponent, reactive, SetupContext, toRef, toRefs, watch } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import { User } from "../../modules/teacher/TeacherList"


interface Data {
  currentUser: any;
  users: User[];
  errors: string[];
  condition: {
    role: string,
    curriculum_id: string,
    name: string,
  };
  isAllCheckedDelete: boolean;
  isAllCheckedActive: boolean;
  password_ids: number[];
  delete_ids: number[];
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      currentUser: context.root.$store.state.currentUser,
      users: [],
      errors: [],
      condition: {
        role: "",
        curriculum_id: "",
        name: ""
      },
      isAllCheckedDelete: false,
      isAllCheckedActive: false,
      password_ids: [],
      delete_ids: [],
    });


    /******************************
     * methods
     ******************************/

    const clearCondition = (): void => {
      state.condition.role = "";
      state.condition.curriculum_id = "";
      state.condition.name = "";
    }

    /**
     * ユーザ一覧検索処理
     */
    const searchUsers = async (): Promise<void> => {
      
      context.root.$store.dispatch("showOverlay", `データ取得中... しばらくお待ちください。`);

      state.errors = [];
  
      await http.get(`/api/teacher/entrance_teacher_list?${Common.BuildQuery(state.condition, 'search_user')}`).then(response => {

        // 検索結果設定
        state.users = response.data.users.map((x: any) => new User(x, context.root.$store.state.curriculums));

        /* ** 初期化 ** */
        state.password_ids = [];
        state.delete_ids = [];
        state.isAllCheckedDelete = false;
        state.isAllCheckedActive = false;
      })
      .catch(error => {

        if (error.response.status == 422) {
          state.errors = error.response.data.errors;
        } else {
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /**
     * ユーザ削除処理
     */
    const usersDelete = async (): Promise<void> => {

      if (!state.delete_ids.length) {
        alert(`削除する教師をチェックしてください。`);
        return;
      }

      if (!confirm(`本当に削除してよろしいでしょうか？`)) {
        return;
      }

      if (state.delete_ids.includes(context.root.$store.state.currentUser.id)) {
        if (!confirm(`ログイン者も削除対象ですが削除してよろしいでしょうか？`)) {
          return;
        }
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher/entrance_teacher_list/delete_users`, {ids: state.delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      searchUsers();
    }

    /**
     * 教科保存処理
     */
    const updateCurriculum = async (): Promise<void> => {

      if (!confirm(`教科を更新します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher/entrance_teacher_list/update_curriculum`, {users: state.users}).then(response => {
        alert(`教科の更新が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      searchUsers();
    }

    /**
     * 教科保存処理
     */
    const updateUserActive = async (): Promise<void> => {

      if (!confirm(`有効/無効状態を更新します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher/entrance_teacher_list/update_active`, {users: state.users}).then(response => {
        alert(`有効/無効状態の更新が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      searchUsers();
    }

    const getConvertDate = (date: string, format: string): string => {
      if (!date) {
        return "-";
      }

      return Common.formatDate(date, format);
    }

    const to = (path: string, query: {[key: string]: string}): void => {

      if (query == null) {
        context.root.$router.push({path: path}).catch(err => {});
      } else {
        context.root.$router.push({path: path, query: query}).catch(err => {});
      }
    }


    /******************************
     * created
     ******************************/
    
    searchUsers();

    /******************************
     * watch
     ******************************/

    watch(() => state.isAllCheckedDelete, (newVal, oldVal) => {

      state.delete_ids = [];

      if (newVal) {

        state.delete_ids = state.users.map(x => x.id);
      }
    });

    watch(() => state.isAllCheckedActive, (newVal, oldVal) => {
      state.users.forEach(x => x.is_active = newVal);
    });


    return {
      ...toRefs(state),
      clearCondition,
      searchUsers,
      usersDelete,
      updateCurriculum,
      updateUserActive,
      getConvertDate,
      to,
    };
  },
})
